var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-tile-macro.j2"] = require( "macros/product-tile-macro.j2" );
dependencies["category-inline-content-slot.j2"] = require( "category-inline-content-slot.j2" );
dependencies["category-empty.j2"] = require( "category-empty.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-grid.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n";
env.getTemplate("macros/product-tile-macro.j2", false, "category/templates/category-grid.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayProductTile")) {
var t_4 = t_1.displayProductTile;
} else {
cb(new Error("cannot import 'displayProductTile'")); return;
}
context.setVariable("displayProductTile", t_4);
output += "\n\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"renderedRecords")) {
output += "\n\n    ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"renderedRecords")), env.opts.autoescape);
output += "\n\n";
;
}
else {
output += "\n\n    <div class=\"";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"totalRecordCount") > 0?"s-category-grid":""), env.opts.autoescape);
output += " o-row o-column o-extra-small--12 js-category-grid\" data-qa-product-grid>";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"totalRecordCount") > 0) {
var t_5;
t_5 = env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug")),{});
frame.set("navItem", t_5, true);
if(frame.topLevel) {
context.setVariable("navItem", t_5);
}
if(frame.topLevel) {
context.addExport("navItem", t_5);
}
var t_6;
t_6 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"tileOptions")),"default_tile_template");
frame.set("defaultTileTemplate", t_6, true);
if(frame.topLevel) {
context.setVariable("defaultTileTemplate", t_6);
}
if(frame.topLevel) {
context.addExport("defaultTileTemplate", t_6);
}
output += "\n            ";
var t_7;
t_7 = env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"templateOptions")),"tileTemplate"),runtime.contextOrFrameLookup(context, frame, "defaultTileTemplate"));
frame.set("tileTemplate", t_7, true);
if(frame.topLevel) {
context.setVariable("tileTemplate", t_7);
}
if(frame.topLevel) {
context.addExport("tileTemplate", t_7);
}
var t_8;
t_8 = false;
frame.set("lazy", t_8, true);
if(frame.topLevel) {
context.setVariable("lazy", t_8);
}
if(frame.topLevel) {
context.addExport("lazy", t_8);
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"inlineContentSlots")) {
env.getTemplate("category-inline-content-slot.j2", false, "category/templates/category-grid.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
})});
}
var t_13;
t_13 = (lineno = 23, colno = 52, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "isFeatureEnabled"), "isFeatureEnabled", context, [runtime.contextOrFrameLookup(context, frame, "core"),"favorites"]));
frame.set("displayFavorites", t_13, true);
if(frame.topLevel) {
context.setVariable("displayFavorites", t_13);
}
if(frame.topLevel) {
context.addExport("displayFavorites", t_13);
}
output += "\n\n            ";
frame = frame.push();
var t_16 = env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"records"),[]);
if(t_16) {var t_15 = t_16.length;
for(var t_14=0; t_14 < t_16.length; t_14++) {
var t_17 = t_16[t_14];
frame.set("product", t_17);
frame.set("loop.index", t_14 + 1);
frame.set("loop.index0", t_14);
frame.set("loop.revindex", t_15 - t_14);
frame.set("loop.revindex0", t_15 - t_14 - 1);
frame.set("loop.first", t_14 === 0);
frame.set("loop.last", t_14 === t_15 - 1);
frame.set("loop.length", t_15);
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") > 7) {
var t_18;
t_18 = true;
frame.set("lazy", t_18, true);
if(frame.topLevel) {
context.setVariable("lazy", t_18);
}
if(frame.topLevel) {
context.addExport("lazy", t_18);
}
;
}
output += "\n                ";
var t_19;
t_19 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0");
frame.set("loopIndex", t_19, true);
if(frame.topLevel) {
context.setVariable("loopIndex", t_19);
}
if(frame.topLevel) {
context.addExport("loopIndex", t_19);
}
output += "\n\n                ";
var t_20;
t_20 = (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_17),"allMeta")),"tile")),"product")),"hasVideo")?runtime.contextOrFrameLookup(context, frame, "True"):runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("displayVideo", t_20, true);
if(frame.topLevel) {
context.setVariable("displayVideo", t_20);
}
if(frame.topLevel) {
context.addExport("displayVideo", t_20);
}
output += "\n\n                ";
output += runtime.suppressValue((lineno = 33, colno = 35, runtime.callWrap(t_4, "displayProductTile", context, [runtime.memberLookup((runtime.memberLookup((t_17),"allMeta")),"tile"),runtime.makeKeywordArgs({"imageId": runtime.contextOrFrameLookup(context, frame, "leadImageViewCode"),"altImageId": runtime.contextOrFrameLookup(context, frame, "hoverImageViewCode"),"tileTemplate": runtime.contextOrFrameLookup(context, frame, "tileTemplate"),"productIndex": runtime.contextOrFrameLookup(context, frame, "loopIndex"),"displayVideo": runtime.contextOrFrameLookup(context, frame, "displayVideo"),"displayFavorites": runtime.contextOrFrameLookup(context, frame, "displayFavorites"),"lazy": runtime.contextOrFrameLookup(context, frame, "lazy")})])), env.opts.autoescape);
output += "\n\n            ";
;
}
}
frame = frame.pop();
;
}
else {
env.getTemplate("category-empty.j2", false, "category/templates/category-grid.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
})});
}
output += "</div>\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-grid.j2"] , dependencies)